module.exports = __webpack_public_path__ + "static/media/goldbbee3c5656b3bde094b47fdc59deb869.webp";